import Typecheck from "../../../utils/Typecheck";

export interface SaveForPresetPayload {
    action: string,
    nonce: string,
    image: string,
    componentsIds: string[],
}

export interface SaveForPresetResponse {
    imageId: number | string,
}

export const isSaveForPresetResponse = (content: unknown): content is SaveForPresetResponse => {
    return Typecheck.isObject(content) &&
        Typecheck.has(content, 'imageId') &&
        Typecheck.isStringOrNumber(content.imageId);
}
